<template>
  <div class="d-flex align-center justify-center text-center text--secondary fill-height">
    <div>
      <i
        class="mb-4"
        v-if="icon"
      >
        <Icon
          :size="30"
          color="#D5DBDB"
          :icon="icon"
        />
      </i>

      <h3
        v-if="title"
        class="font-weight-bold mb-2"
        style="color: #444"
      >
        {{ title }}
      </h3>
      <h4
        v-if="description"
        class="font-weight-regular mb-0"
      >
        {{ description }}
      </h4>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  }
})
export default class Empty extends Vue {}
</script>
